module.exports = __webpack_public_path__ + "img/demo.4cf0e816.jpg";